module.exports = __webpack_public_path__ + "img/ico_print.0141a057.png";